import { Box, FormGroup, Typography } from "@mui/material";

import { CONVERSATION_LENS } from "../../../utils/terminology";
import { useCoachingGeneratorStore } from "../store/coachingGeneratorStore";
import ContextCheckbox from "./ContextCheckbox";

interface ContextOptionsProps {
  attributeStatsContent: string | null;
  lensDefinitionContent: string | null;
  teamBestPracticesContent: string | null;
}

const ContextOptions = ({
  attributeStatsContent,
  lensDefinitionContent,
  teamBestPracticesContent
}: ContextOptionsProps) => {
  const {
    includeAttributeStats,
    includeLensDefinition,
    includeTeamBestPractices,
    setIncludeAttributeStats,
    setIncludeLensDefinition,
    setIncludeTeamBestPractices
  } = useCoachingGeneratorStore();

  const contextOptions = [
    {
      checked: includeAttributeStats,
      onChange: setIncludeAttributeStats,
      label: "Include Attribute Performance Statistics",
      content: attributeStatsContent
    },
    {
      checked: includeLensDefinition,
      onChange: setIncludeLensDefinition,
      label: `Include ${CONVERSATION_LENS} Definition`,
      content: lensDefinitionContent
    },
    {
      checked: includeTeamBestPractices,
      onChange: setIncludeTeamBestPractices,
      label: "Include Team Best Practices",
      content: teamBestPracticesContent
    }
  ];

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Additional Context
      </Typography>
      <FormGroup>
        {contextOptions.map((option) => (
          <ContextCheckbox key={option.label} {...option} />
        ))}
      </FormGroup>
    </Box>
  );
};

export default ContextOptions;
